import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSubscribeIconCorporate = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={46} height={40} fill="none" {...props}>
    <path fill="#FFF4F0" d="M1.795 10.257h42.308v28.205H1.795z" />
    <path
      fill="#6E0F0F"
      d="M2.308 13.459a3.202 3.202 0 0 1 3.202-3.202h34.877a3.202 3.202 0 0 1 3.203 3.202c0 7.86-6.373 14.233-14.234 14.233H16.541c-7.86 0-14.233-6.372-14.233-14.233Z"
    />
    <path
      fill="#6E0F0F"
      fillRule="evenodd"
      d="M41.63 8h-9.454V1.333A1.327 1.327 0 0 0 30.843 0H14.797a1.335 1.335 0 0 0-1.341 1.333V8H4.009A4.008 4.008 0 0 0 0 12v26.667A1.334 1.334 0 0 0 1.333 40h42.971a1.33 1.33 0 0 0 1.337-1.333V12a4.008 4.008 0 0 0-4.01-4h-.001ZM16.132 2.666h13.37V8h-13.37V2.666ZM2.672 12c0-.738.6-1.334 1.337-1.334H41.63A1.336 1.336 0 0 1 42.965 12v2.666a12.035 12.035 0 0 1-3.573 8.498 12.119 12.119 0 0 1-8.548 3.501H14.797a12.104 12.104 0 0 1-8.55-3.5 12.047 12.047 0 0 1-3.575-8.5V12Zm40.293 25.334H2.672V23.066a14.836 14.836 0 0 0 12.125 6.267h16.047a14.828 14.828 0 0 0 12.12-6.266l.001 14.267Zm-24.16-14.668c0-.735.6-1.333 1.34-1.335h5.352c.735.002 1.332.6 1.332 1.333 0 .735-.597 1.33-1.332 1.333h-5.352a1.328 1.328 0 0 1-.946-.388 1.324 1.324 0 0 1-.393-.943Z"
      clipRule="evenodd"
    />
    <rect width={12.82} height={2.564} x={16.41} y={22.821} fill="#FFF4F0" rx={1.282} />
  </svg>
);
export default SvgSubscribeIconCorporate;
